import { createSlice } from "@reduxjs/toolkit";

const storedToken = sessionStorage.getItem('token');

const initialState = {
  mode: "light",
  userId: null,
  userName: null,
  userEmail: null,
  token: storedToken || null,
  userRole: null,
  userLastName: null, 
  img: null,
  pseudo : null,
  workshop : null,
  passType : null
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    signIn: (state, action) => {
      state.token = action.payload;
    },
    logOut: () => initialState,
    setUserInfo: (state, action) => {
      const { userId, userName, userEmail, userLastName, userRole, img, pseudo, passType, workshop } = action.payload;
      state.userId = userId;
      state.userName = userName;
      state.userEmail = userEmail;
      state.userLastName = userLastName;
      state.userRole = userRole;
      state.img = img;
      state.pseudo = pseudo;
      state.passType = passType || null;
      state.workshop = workshop || null;
    },
    // New reducer for updating passType and workshop only
    updatePassInfo: (state, action) => {
      const { passType, workshop } = action.payload;
      if (passType !== undefined) state.passType = passType;
      if (workshop !== undefined) state.workshop = workshop;
    },
  },
});

export const { setMode, signIn, logOut, setUserInfo, updatePassInfo } = globalSlice.actions;

export default globalSlice.reducer;